import React from 'react';
import { Bell, Settings, ChevronDown, User } from 'lucide-react';
export const TopBar = () => {
  return <div className="h-12 border-b flex items-center justify-between px-4" data-id="element-676">
      <div className="font-medium text-gray-700" data-id="element-677">Conversations</div>
      <div className="flex items-center gap-4" data-id="element-678">
        <div className="relative" data-id="element-679">
          <Bell size={18} className="text-gray-500" data-id="element-680" />
          <div className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-red-500 rounded-full flex items-center justify-center" data-id="element-681">
            <span className="text-[8px] text-white" data-id="element-682">1</span>
          </div>
        </div>
        <Settings size={18} className="text-gray-500" data-id="element-683" />
        <div className="flex items-center gap-1 text-gray-700" data-id="element-684">
          <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-685"></div>
          <span className="text-sm" data-id="element-686">Available</span>
          <ChevronDown size={16} data-id="element-687" />
        </div>
        <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center" data-id="element-688">
          <User size={16} className="text-gray-500" data-id="element-689" />
        </div>
      </div>
    </div>;
};